// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #ffffff;
}

/* Sewa International inspired color palette */
:root {
  --primary-orange: #FF6B35;
  --primary-blue: #1E3A8A;
  --secondary-green: #059669;
  --warm-gold: #F59E0B;
  --light-gray: #F8FAFC;
  --medium-gray: #64748B;
  --dark-gray: #1E293B;
  --white: #FFFFFF;
  --text-on-dark: #FFFFFF;
  --text-on-light: #1E293B;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-padding {
  padding: 80px 0;
}

.text-center {
  text-align: center;
}

.text-white {
  color: white !important;
}

.text-on-dark {
  color: white !important;
}

.btn {
  display: inline-block;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
}

.btn-primary {
  background-color: var(--primary-orange);
  color: white;
}

.btn-primary:hover {
  background-color: #E85527;
  transform: translateY(-2px);
}

.btn-secondary {
  background-color: var(--primary-blue);
  color: white;
}

.btn-secondary:hover {
  background-color: #1E40AF;
  transform: translateY(-2px);
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 16px;
}

h1 {
  font-size: 3rem;
  color: var(--primary-blue);
}

h2 {
  font-size: 2.5rem;
  color: var(--primary-blue);
}

h3 {
  font-size: 2rem;
  color: var(--dark-gray);
}

p {
  margin-bottom: 16px;
  color: var(--medium-gray);
}

/* Ensure proper contrast on colored backgrounds */
.text-on-dark, 
[class*="gradient"] p,
[style*="background: linear-gradient"] p,
[style*="background:linear-gradient"] p {
  color: white !important;
}

/* Specific overrides for dark background sections */
section[style*="background: linear-gradient"] h1,
section[style*="background: linear-gradient"] h2,
section[style*="background: linear-gradient"] h3,
section[style*="background: linear-gradient"] p {
  color: white !important;
}

@media (max-width: 768px) {
  h1 {
    font-size: 2.5rem;
  }
  
  h2 {
    font-size: 2rem;
  }
  
  .section-padding {
    padding: 60px 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;;;;EAIE,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  line-height: 1.6;\n  color: #333;\n  background-color: #ffffff;\n}\n\n/* Sewa International inspired color palette */\n:root {\n  --primary-orange: #FF6B35;\n  --primary-blue: #1E3A8A;\n  --secondary-green: #059669;\n  --warm-gold: #F59E0B;\n  --light-gray: #F8FAFC;\n  --medium-gray: #64748B;\n  --dark-gray: #1E293B;\n  --white: #FFFFFF;\n  --text-on-dark: #FFFFFF;\n  --text-on-light: #1E293B;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.section-padding {\n  padding: 80px 0;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-white {\n  color: white !important;\n}\n\n.text-on-dark {\n  color: white !important;\n}\n\n.btn {\n  display: inline-block;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 16px;\n}\n\n.btn-primary {\n  background-color: var(--primary-orange);\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #E85527;\n  transform: translateY(-2px);\n}\n\n.btn-secondary {\n  background-color: var(--primary-blue);\n  color: white;\n}\n\n.btn-secondary:hover {\n  background-color: #1E40AF;\n  transform: translateY(-2px);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  line-height: 1.3;\n  margin-bottom: 16px;\n}\n\nh1 {\n  font-size: 3rem;\n  color: var(--primary-blue);\n}\n\nh2 {\n  font-size: 2.5rem;\n  color: var(--primary-blue);\n}\n\nh3 {\n  font-size: 2rem;\n  color: var(--dark-gray);\n}\n\np {\n  margin-bottom: 16px;\n  color: var(--medium-gray);\n}\n\n/* Ensure proper contrast on colored backgrounds */\n.text-on-dark, \n[class*=\"gradient\"] p,\n[style*=\"background: linear-gradient\"] p,\n[style*=\"background:linear-gradient\"] p {\n  color: white !important;\n}\n\n/* Specific overrides for dark background sections */\nsection[style*=\"background: linear-gradient\"] h1,\nsection[style*=\"background: linear-gradient\"] h2,\nsection[style*=\"background: linear-gradient\"] h3,\nsection[style*=\"background: linear-gradient\"] p {\n  color: white !important;\n}\n\n@media (max-width: 768px) {\n  h1 {\n    font-size: 2.5rem;\n  }\n  \n  h2 {\n    font-size: 2rem;\n  }\n  \n  .section-padding {\n    padding: 60px 0;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
